/*
    Imports the HMB API URL from the config.
*/
import {APP_CONFIG} from "../config"

export default {
    /*
        GET     /v1/security/api-apps
    */
    getApps: function () {
        return axios.get(`${APP_CONFIG.URL}security/api-apps`);
    },

    /*
      GET   /v1/security/api-apps/{appID}
    */
    getApp: function (appID) {
        return axios.get(APP_CONFIG.URL + 'security/api-apps/' + appID);
    },

    /*
      GET   /v1/security/api-apps/{appID}
    */
    revokeApp: function (appID) {
        return axios.delete(APP_CONFIG.URL + 'security/api-apps/' + appID);
    },

    /*
      POST  /v1/security/api-apps
    */
    postCreateApp: function (payload) {
        return axios.post(`${APP_CONFIG.URL}security/api-apps`, payload);
    }
}
